import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import { useFormikContext, ErrorMessage } from 'formik'

import scssVars from '~components/scss-variables'
import { AddressGeocode } from '~components/AddressGeocode'

import { Field, Dropdown, Radio, CheckBox , Input} from '../../Services/Payment/Components'

import {  Field as RawField } from 'formik'
import { InlineError } from '../Shared/Components'
import States from './50states'

const Label = styled.label`
  font-family: 'Montserrat', sans-serif;
  margin-left: 10px;
  vertical-align: top;
  font-size: 16px;
  line-height: 1.5;
  cursor: pointer;
`

// const Doorman = styled.div`
//   margin: 25px 0 25px 0;
//   max-width: 90%;
//   position: relative;

//   ${CheckBox} {
//     position: absolute;
//   }

//   ${Label} {
//     padding-left: 20px;
//   }
// `

const Address = styled.div`
  margin-top: 15px;

  ${Field} {
    font-family: 'Montserrat', sans-serif;
    padding: 0 0 5px 10px;
    height: 35px;
    margin-bottom: 20px;
    width: 100%;
    border-bottom: 1px solid ${scssVars.beige};
  }
  ${InlineError} {
    top: -15px;
  }
`

const validate = value => !value ? <InlineError>This field is required</InlineError> : undefined

const AddressForm = ({ fieldPrefix, doormanLabel }) => {
  const { setFieldValue } = useFormikContext()
  const [isResidential, setResidential] = useState(true)

  const setRadio = (e) => {
    const checked = e.target.value === "true"
    setResidential(!isResidential)
    setFieldValue(`${fieldPrefix}[isResidential]`, checked)
  }

  return (
    <div>
      <Row className="mt-4">
        <Col>
          <Radio type="radio" name={`${fieldPrefix}[isResidential]`} id={`${fieldPrefix}[isResidential]`} value={true} checked={isResidential} onChange={setRadio} />
          <Label htmlFor={`${fieldPrefix}[isResidential]`}>
            Residential
          </Label>
        </Col>
        <Col>
          <Radio type="radio" name={`${fieldPrefix}[isResidential]`} id={`${fieldPrefix}[isCommercial]`} value={false} checked={!isResidential} onChange={setRadio} />
          <Label htmlFor={`${fieldPrefix}[isCommercial]`}>
            Commercial
          </Label>
        </Col>
      </Row>
      <ErrorMessage name={`${fieldPrefix}[isResidential]`} />
      <Address>
        <div>
          <Field type="text" name={`${fieldPrefix}[name]`} placeholder="Recipient Name / Company Name" validate={validate} required />
          <ErrorMessage name={`${fieldPrefix}[name]`} />
        </div>
        <div>
          {/* <Field type="text" name={`${fieldPrefix}[street]`} placeholder="Street Address" validate={validate} required /> */}
          <RawField >
            {({ field, form, meta }) => (
                <AddressGeocode component ={Input} className ="form-control" name={`${fieldPrefix}[street]`} placeholder="Street Address" type="text" required form={form} onSelected={address => {
                  if (address?.mapboxId) {
                    form.setFieldValue(`${fieldPrefix}[city]`, address.city)
                    form.setFieldValue(`${fieldPrefix}[postalCode]`, address.postalCode)
                    form.setFieldValue(`${fieldPrefix}[stateCode]`, address.stateCode)
                    form.setFieldValue(`${fieldPrefix}[mapboxId]`, address.mapboxId)
                    form.setFieldValue(`${fieldPrefix}[latitude]`, address.coordinates[1])
                    form.setFieldValue(`${fieldPrefix}[longitude]`, address.coordinates[0])
                  }
              }}/>
            )}
          </RawField>
          <ErrorMessage name={`${fieldPrefix}[street]`} />
        </div>
        <div>
          <Field type="text" name={`${fieldPrefix}[addressLine2]`} placeholder="Apt / Suite / Floor" />
        </div>
        <div>
          <Field type="text" name={`${fieldPrefix}[city]`} placeholder="City" validate={validate} required />
          <ErrorMessage name={`${fieldPrefix}[city]`} />
        </div>
        <Row>
          <Col>
            <Dropdown component="select" name={`${fieldPrefix}[stateCode]`} className="form-control" validate={validate} required >
              <option value="">State</option>
              <States />
            </Dropdown>
            <ErrorMessage name={`${fieldPrefix}[stateCode]`} />
          </Col>
          <Col>
            <Field type="text" name={`${fieldPrefix}[postalCode]`} placeholder="Zipcode" validate={validate} required />
            <ErrorMessage name={`${fieldPrefix}[postalCode]`} />
          </Col>
        </Row>
        <input type="hidden" value="" name={`${fieldPrefix}[mapboxId]`} />
        <input type="hidden" value="" name={`${fieldPrefix}[latitude]`} />
        <input type="hidden" value="" name={`${fieldPrefix}[longitude]`} />
        <NumberFormat type="tel"
          className="form-control mb-3"
          name={`${fieldPrefix}[phoneNumber]`}
          format="+1 ### ### ####"
          placeholder="Phone number*"
          customInput={Field}
          required
        />
        <ErrorMessage name={`${fieldPrefix}[phoneNumber]`} />
      </Address>
      {/* <Doorman>
        <CheckBox type="checkbox" id={`${fieldPrefix}[hasDoorman]`} name={`${fieldPrefix}[hasDoorman]`} />
        <Label htmlFor={`${fieldPrefix}[hasDoorman]`}>{doormanLabel || 'I will leave my item(s) with my doorman or front desk.'}</Label>
        <ErrorMessage name={`${fieldPrefix}[hasDoorman]`} />
      </Doorman> */}
    </div>
  )
}

AddressForm.propTypes = {
  fieldPrefix: PropTypes.string.isRequired,
  doormanLabel: PropTypes.string
}

export default AddressForm
